import type { FaireProductEntity } from "../../entity_types/product";

export const p_4259dwah8y: FaireProductEntity = {
  token: "p_4259dwah8y",
  type: "product",
  name: "Crow & Crystal Mini Spirit Board.",
  brandToken: "b_8h5sk43qpz",
  brandName: "Down To Earth",
  imageUrl:
    "https://cdn.faire.com/fastly/8cff05cb2e72c8d72b25ddc8f97386c2c60e54c01c02469a7b37b0b5f4809b5b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b24f4f387b9a2c160f9e954e20432ad46a07875ea9e2393e2cb3af19573955a2.jpeg",
    "https://cdn.faire.com/fastly/387f58c6c2af727b6786ea9c225eae4326f1a5f2fcacd61663c6df7cc8408bbd.jpeg",
    "https://cdn.faire.com/fastly/b0f7e850c19265a41bbdcf89cc229b2f859a95c34604b3d8d08890927320ca84.jpeg",
    "https://cdn.faire.com/fastly/22888bf88e2afd270365b200fc61e32aea572202aeb39354ce941f96abd76eef.jpeg",
  ],
  priceDollars: 6,
  description:
    "The Crow & Crystal Mini Spirit Board is a compact divination tool featuring detailed engraved artwork on a sleek black wooden board. Measuring 9” wide by 6” high, it includes the full alphabet, numbers 0–9, Yes, No, and Good Bye, framed by symbolic imagery of a crow skull, crescent moons, feathers, and crystal accents. Its smaller size makes it ideal for travel, altar displays, or personal readings. Crafted for smooth planchette movement and clear visibility, this mini spirit board is perfect for collectors, practitioners, or anyone drawn to gothic and mystical décor.\n\n * 9”W x 6”H ",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:44.341Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
